// useCommonStyles.js
import { useMemo } from 'react';
import { Platform, StyleSheet } from 'react-native';
import { useResponsiveFontSize } from '@/hooks/useResponsiveDimensions';

import colors from '@/config/colors';

export const useCommonStyles = () => {
  const fontSize = useResponsiveFontSize(1.7);
  const titleresponsiveFonrSize = useResponsiveFontSize(1.9);
  const iconSize = useResponsiveFontSize(4);

  const styles = useMemo(() => {
    return StyleSheet.create({
      zurück: {
        fontSize: Platform.OS === 'web' ? 24 : fontSize,
        textAlign: 'center',
      },
      topButtonIconSize: {
        fontSize: iconSize,
      },
      titles: {
        fontSize: Platform.OS === 'web' ? 30 : titleresponsiveFonrSize,
        textAlign: 'center',
        fontWeight: '700',
        color: colors.white,
        //flex:1,
      },
      // Define any other common styles here..
    });
  }, [iconSize, fontSize]);

  return styles;
};
